import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, APP_INITIALIZER, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { PlatformLocation } from '@angular/common';
import { ConfigService } from './core/services/config.service';
import { AuthService } from './core/services/auth.service';

import { routes } from './app.routes';

// APP_INITIALIZER factory function
function initializeApp() {
  return () => {
    const configService = inject(ConfigService);
    const authService = inject(AuthService);
    const platformLocation = inject(PlatformLocation);
    
    // Load system configuration first
    return firstValueFrom(configService.loadSysConfig(platformLocation));
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      progressBar: true,
      closeButton: true
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true
    }
  ]
};
